export default __webpack_public_path__ + "static/media/project-img.f9923c32.jpg";